import React from "react";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

export default function LightGallery({ index, list, onclose }) {
   let listAarry = list.map((item) => ({ src: item.img }));
   return (
      <Lightbox //
         index={index}
         open={index >= 0}
         close={() => onclose()}
         slides={[...listAarry]}
         plugins={[Thumbnails]}
      />
   );
}

/*
 how to use  LightGallery 
 1 .  const [index, setIndex] = useState(-1);
 2 .  add onClick event in map item  onClick={() => setIndex(currentIndex)}
 3 .  use component out side of loop
      <LightGallery index={index} list={array} onclose={() => setIndex(-1)} />
note - in array img key name should be exist
*/
